<template>
    <div id="page">

        <div class="page-content">
            <div class="fixed-top-box">
                <div class="page-title page-title-small">
                    <h2>
                        پروژه
                    </h2>
                    <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                    <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
                </div>
                <div class="card header-card shape-rounded" data-card-height="100">
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                </div>
                <div class="card card-style mb-2">
                    <div class="p-3 d-flex">
                        <button id="filterBtn" type="button" class="btn btn-xs rounded-m brand-bg-color ml-1" data-toggle="modal" data-target="#searchModal" style="max-height:31px!important">
                            <i class="fa fa-filter text-white"></i>
                        </button>
                        <div class="filter-row-scrollable">

                        </div>
                    </div>
                </div>
            </div>
            <span data-menu="menu-language" class="optionMenu"></span>
            <div class="main-content-box">
                <div :class="{'bg-Start' : item.lastStatus ,'bg-Regist' : item.regist}" class="card card-style mb-2" v-for="item in GetProjectList" :key="item.projectId">
                    <div class="py-2 px-3">
                        <div class="d-flex justify-content-between rounded-sm font-900 w-100 mb-0">
                            <span class="font-weight-bold font-13 text-dark">{{item.code}}-{{item.title}}</span>
                            <span @click.stop="showMenu(item)" class="text-left" style="width:25px"><i class="fa fa-ellipsis-v font-14"></i></span>
                        </div>
                        <span class="userTitle w-100">{{item.userTitle}}</span>
                        <div class="d-flex justify-content-between">
                            <span v-if="item.startDate!=null && item.startDate!=''" class="text-muted font-12">از تاریخ: <span class="d-inline-block ltr">{{item.startDate}}</span></span>
                            <span v-if="item.endDate!=null && item.endDate!=''" class="text-muted font-12">تا تاریخ: <span class="d-inline-block ltr">{{item.endDate}}</span></span>
                        </div>
                        <span v-if="(!isMinVersion) && (item.personTitle!=null && item.personTitle!='')" class="userTitle w-100">طرف حساب: {{item.personTitle}}</span>
                    </div>
                </div>
            </div>
            <div class="card card-style" v-if="GetProjectList.length==0 && Loading==false">
                <div class="content">
                    <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                    <p class="text-center py-3">اطلاعاتی یافت نشد.</p>
                </div>
            </div>
        </div>
        <transition v-if="!isMinVersion" enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn">
                <router-link to="/AddOrEditProject">
                    <div class="icon icon-m rounded-m color-white bg-green2-light">
                        <i class="fa fa-plus"></i>
                    </div>
                </router-link>
            </div>
        </transition>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading==true" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
            </div>
        </transition>
        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'AddOrEditProject', params: { projectId: projectId  } }" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-edit color-yellow1-light float-right font-14"></i>ویرایش</span><i class="fa fa-angle-left"></i></router-link>
                    <button @click="AddChild()" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-search color-green2-light float-right font-14"></i>تعریف زیر مجموعه</span><i class="fa fa-angle-left"></i></button>
                    <button @click="DeleteProject" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>

                </div>
                <div class="clear"></div>
            </div>
        </div>
        <Help-Menu title="معرفی اپلیکیشن تسکینو" keyEn="TaskList" v-if="isKarnegasht==false"></Help-Menu>
        <Help-Menu title="معرفی اپلیکیشن کارنگاشت" keyEn="TaskList" v-if="isKarnegasht==true"></Help-Menu>
    </div>
    <div id="searchModal" class="modal fade" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header align-items-center">
                    <h4 class="modal-title mt-0">جستجو</h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body m-0">
                    <div class="mb-3">
                        <div class="w-100 search-box rounded-m position-relative">
                            <i class="fa fa-search pr-3"></i>
                            <input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey">
                        </div>
                    </div>

                    <button type="button" class="btn btn-xxs btn-full bg-green1-dark rounded-sm font-900 w-100" data-dismiss="modal" @click="filterList()">
                        <i class="fa fa-search ml-2"></i>
                        جستجو
                    </button>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import VueSimpleAlert from "vue3-simple-alert";
    import HelpMenu from '../Components/HelpMenu.vue';
    import router from '../../router';
    export default {
        components: {
            "Help-Menu": HelpMenu,
        },
        data() {
            return {
                searchKey: "",
                projectId: 0,
                levelId: 1,
                pageLoaded: false
            };
        },
        computed: {
            GetProjectList() {
                return this.$store.getters.GetAllProjectList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            },
            NoMoreData() {
                return this.$store.getters.GetProjectNoMoreData;
            },
        },
        created() {
            this.$store.dispatch("GetAllProjectListFromServer", { text: "" });
            this.$store.dispatch("GetAllProjectListFromServer", { text: "" });
        },
        mounted() {
            this.showAddButton();
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        },
        activated() {
            this.showAddButton();
        },
        methods: {
            AddChild() {
                document.getElementsByClassName('menu-hider')[0].click();
                this.$http.get("Project/GetProjectLevelItem", {
                    params: {
                        id: this.levelId+1,
                    }
                }).then(data => {
                    if (!data.data.isSuccess) {
                        this.showErrorMessage("امکان تعریف زیرمجموعه برای این پروژه وجود ندارد ");
           
                    } else {
                        router.push({ name: 'AddOrEditProject', params: { projectId:0, parentId:this.projectId } });
                    }
                });
            },
            filterList() {
                this.$store.dispatch("GetAllProjectListFromServer", { text: this.searchKey });
            },
            showAddButton() {
                this.pageLoaded = true;
            },
            showMenu(item) {
                this.levelId = item.levelId;
                this.projectId = item.projectId;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            DeleteProject() {
                document.getElementsByClassName('menu-hider')[0].click();
                VueSimpleAlert.confirm("آیا مایل به حذف این مورد هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.$http
                        .get(
                            "Project/Delete?id=" +
                            this.projectId
                        )
                        .then((data) => {
                            if (data.data.isSuccess) {
                                this.showSuccessMessage(data.data.message);
                                /*this.$store.dispatch("GetProjectListFromServer", { text: "" });*/
                                this.$store.dispatch("GetAllProjectListFromServer", { text: "" });
                            } else {
                                this.showErrorMessage(data.data.message);
                            }
                        })
                });
            },
        }
    };
</script>
